<script setup lang="ts">
import type {InvoiceFilter, InvoiceFilters} from "@/types/Wiser/invoice.ts";
import {ref, watch} from "vue";

const model = defineModel<InvoiceFilter>({required: true});
const filters = ref<InvoiceFilters>({})
watch(filters, (newValue) => {
  const filterString = Object.entries(newValue)
    .filter(([, value]) => value !== '')
    .map(([key, value]) => `${key}${['title'].includes(key)?'%=':'='}${encodeURIComponent(value)}`)
    .join(',')
  model.value.filters = encodeURI(filterString);
}, {deep: true})
</script>

<template>
  <form class="wiser-filter__form invoice-filter__form">
    <input v-model="filters.id" placeholder="Wiser ID" type="text" />
    <input v-model="filters.factuurnummer" placeholder="Factuurnummer" type="text" />
    <input v-model="filters.factuurdatum" placeholder="Factuurdatum" type="date" />
    <select v-model="model.page">
      <option v-for="num of [...Array(25).keys()]" :value="String(num + 1)">{{ num + 1 }}</option>
    </select>
    <select v-model="model.perPage">
      <option v-for="num of [...Array(4).keys()]" :value="String((num + 1)*25)">{{ (num + 1)*25 }}</option>
    </select>
  </form>
</template>

<style scoped>
 form {
   width: 100%;
 }
</style>
